import axios from "axios";

const BASE = process.env.REACT_APP_BASE_API_URL;

const post = (url, extraFields = {}) => {
  const token = localStorage.token;
  const fData = new FormData();
  fData.append("token", token);
  Object.entries(extraFields).forEach(([key, value]) => {
    if (value !== undefined && value !== null) fData.append(key, value);
  });

  return axios.post(`${BASE}${url}`, fData).then((res) => {
    if (res.data?.type === "success") return res.data.payload;
    throw new Error(res.data?.payload || "Unexpected server response");
  });
};

export const getSummary = () => post("/admin/notifications/get_summary");

export const getList = ({ page, perPage, entityType, isRead } = {}) =>
  post("/admin/notifications/get_list", {
    page,
    per_page: perPage,
    entity_type: entityType,
    is_read: isRead,
  });

export const markRead = (notificationId) =>
  post("/admin/notifications/mark_read", { notification_id: notificationId });

export const markReadByEntity = (entityType, entityId) =>
  post("/admin/notifications/mark_read_by_entity", { entity_type: entityType, entity_id: entityId });

// With no entity type this marks ordinary notifications only; scope "store"
// marks the homepage's Store alerts instead.
export const markAllRead = (entityType, scope) =>
  post("/admin/notifications/mark_all_read", entityType ? { entity_type: entityType } : { scope });

// One grouped Store alert: every row with the same kind and wording as this one.
export const markStoreAlertGroupRead = (notificationId) =>
  post("/admin/notifications/mark_all_read", { same_as: notificationId });

export const getStoreAlerts =({ kind, unreadOnly, page, perPage } = {}) =>
  post("/admin/notifications/get_store_alerts", {
    kind: kind && kind !== "all" ? kind : undefined,
    unread_only: unreadOnly ? "1" : undefined,
    page,
    per_page: perPage,
  });
